import produk from './produk'

export default [
  ...produk,
]
